const FOCUSABLE_ELEMENTS = ['a[href]', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', '[tabindex]:not([tabindex^="-"])'];

export const getFirstFocusable = (parent) => {
  return parent.querySelector(FOCUSABLE_ELEMENTS.join(','));
};

export const getFocusableElements = (el) => {
  return Array.prototype.slice.call(
    $(el).find(FOCUSABLE_ELEMENTS.join(','))
  )
};

const makeTabbable = (el) => {
  if (el.hasAttribute('data-tabindex')) {
    el.setAttribute('tabindex', el.getAttribute('data-tabindex'));
  } else {
    el.removeAttribute('tabindex');
  }
};

const makeUntabbable = (el) => {
  if (el.hasAttribute('tabindex') && !el.classList.contains('untabbed')) {
    el.setAttribute('data-tabindex', el.getAttribute('tabindex'));
  }
  el.classList.add('untabbed');
  el.setAttribute('tabindex', -1);
};

export const toggleTabIndex = (parent, focusable) => {
  var els = getFocusableElements(parent)
  
  focusable
    ? els.forEach(makeTabbable)
    : els.forEach(makeUntabbable)
};